import React, { useState, useEffect, useRef } from "react";
import Player from "@vimeo/player";
import { connect } from "react-redux";

import { FaPlay } from "react-icons/fa";
import { Skeleton } from '@mui/material';

import VideoControls from "./components/VideoControls";

import { apiCallV2 } from "../../utils/api"
import { socket } from "../../utils/socket";
import { delay } from "../../utils"
import { callSocket } from "../../utils/socket";
import { SaveWorkoutWatchedtime, GetWorkoutWatchedTime, Watching } from '../../redux/v2/workout/actions';
import { AddFinishedWorkoutID } from "../../redux/v2/user/actions";
import { SetVideoDetails, SendCastDetails2 } from "../../redux/v2/cast/actions";

import "./style.css";

let player;

function VideoFeedV2(props) {
    let mobileapp = localStorage.getItem("indi-platform");
    mobileapp = (mobileapp == "null" || mobileapp == null) ? null : mobileapp;

    const { native } = props.Cast;
    const { account } = props.User;
    const { type = "workout", video, label = null, favorite = null, style, thumbParams, setAdditionalDetails = () => { }, onClose = () => { }, isIntro = false } = props;
    const [thumbnail, setThumbnail] = useState(video?.image ? (video?.image + "_720x405") : null);
    const [duration, setDuration] = useState(video?.video_time || 0);
    const [videoURL, setVideoURL] = useState(null);
    const [videoRawURL, setVideoRawURL] = useState(null);
    const [videoTitle, setVideoTitle] = useState("");
    const [timeCounter, setTimeCounter] = useState(0);
    const [watchedTime, setWatchedTime] = useState(0);
    const [castDetails, setCastDetails] = useState(null);
    const [showFeedV2, setShowFeedV2] = useState(false);
    const [playClicked, setPlayClicked] = useState(false);

    const [play, setPlay] = useState(false);
    const [playStatus, setPlayStatus] = useState("play");

    const [isLandscape, setIsLandscape] = useState(false);
    const [showControls, setShowControls] = useState(false);
    const [fadetype, setFadetype] = useState(null);
    const [fadeInD, setFadeInD] = useState(null);
    const [fadeOutD, setFadeOutD] = useState(null);
    const [fadeNoneD, setFadeNoneD] = useState(null);

    const [isCaptionEnabled, setIsCaptionEnabled] = useState(false);

    const iframeRef = useRef(null)
    const iframeRef2 = useRef(null)


    const PlayVideo = async () => {
        delay(() => {
            setIsLandscape(true);
        }, 400)

        player = new Player(iframeRef.current || iframeRef2.current);
        player.ready().then(() => {

            if (native.isPlayingCast) {
                Pause();
            }

            delay(() => {
                FadeController();
            }, 300)
        });
        player.setCurrentTime(watchedTime);
        player.on("timeupdate", (time) => {
            time = Math.round(time.seconds);
            setTimeCounter(t => time);
            setWatchedTime(time);
        });

        player.on("ended", () => {
            if (isIntro) {
                CloseVideo();
            }
        });

        player.getTextTracks()
            .then((tracks) => {
            })
            .catch((error) => {
            });
    };

    const AlwaysShowControls = () => {
        clearTimeout(fadeOutD);
        clearTimeout(fadeNoneD);
        clearTimeout(fadeNoneD);

        setFadetype("in");
        setShowControls(true);
    }

    const FadeController = () => {

        if (fadetype == 'in') {
            clearTimeout(fadeOutD);
            clearTimeout(fadeNoneD);
        } else if (fadetype == 'out') {
            clearTimeout(fadeNoneD);
        }

        setFadeInD(delay(() => {
            setFadetype("in");
            setShowControls(true);

            setFadeOutD(delay(() => {
                setFadetype("out");
                setFadeNoneD(delay(() => {
                    setFadetype("none");
                }, 900));
            }, 3000));

        }, 10))
    }

    const CloseController = () => {
        clearTimeout(fadeOutD);
        clearTimeout(fadeNoneD);

        setFadetype("none");
    }

    const CloseVideo = () => {
        setShowFeedV2(false);
        setPlay(!play)
        setPlayStatus("play");
        setIsLandscape(false);
        setShowControls(false);
        setFadeInD(null);
        setFadeOutD(null);
        setFadeNoneD(null);
        clearTimeout(fadeInD);
        clearTimeout(fadeOutD);
        clearTimeout(fadeNoneD);
        onClose({
            progress: Math.round(timeCounter / duration * 100)
        });
    }

    const Pause = () => {
        player.pause();
        setPlayStatus("pause");
    }

    const Resume = () => {
        player.play();
        setPlayStatus("play");
    }

    const Move = (val) => {
        const newWT = watchedTime + val;
        player.setCurrentTime(newWT);
        callSocket("/interact-native-component", { type: "cast", subtype: "move-position", newWT: newWT });
    }

    const Restart = () => {
        player.setCurrentTime(0);
    }

    const PicInPic = () => {
        player.requestPictureInPicture()
    }

    const SyncFromCast = (wt) => {
        player.setCurrentTime(wt);
        setWatchedTime(wt);
    }

    const PlayCastDevice = () => {
        callSocket("/interact-native-component", { type: "cast", subtype: "play" });
        setPlayStatus("play");
    }

    const PauseCastDevice = () => {
        callSocket("/interact-native-component", { type: "cast", subtype: "pause" });
        setPlayStatus("pause");
    }

    const EnableCaption = () => {
        if (isCaptionEnabled) {
            player.disableTextTrack();
        } else {
            player.enableTextTrack("en")
                .then((track) => {
                })
                .catch((error) => {
                    player.enableTextTrack("en-x-autogen");
                });
        }
        setIsCaptionEnabled(!isCaptionEnabled);
    }




    useEffect(() => {
    }, [native])

    // Setting up previous Watchtime
    useEffect(() => {
        let wt = null;

        if (video?.hasOwnProperty("watchedtime")) {
            wt = video?.watchedtime;
        } else if (video?.progress?.hasOwnProperty("watchedtime")) {
            wt = video?.progress?.watchedtime;
        } else {
            wt = props.Workout.playing["video-id-" + video?.workout_id];
        }

        let per = Math.round(wt / duration * 100);
        let startTime = per > 90 ? 0 : wt;
        setWatchedTime(startTime);
        setCastDetails({
            ...castDetails,
            startTime: startTime,
        });
    }, [props.Workout.playing, duration])

    // Setting up Thumbnail and other video metadata
    useEffect(async () => {
        setThumbnail(null);
        setPlay(false);
        setWatchedTime(0);

        setVideoURL(`https://player.vimeo.com/video/${video?.video_id}?autoplay=1&pip=1${mobileapp ? "&controls=0" : ""}`);
        // if (video?.video_id && video?.video_id !== undefined) {
        if (video?.video_id) {
            if (type === "workout" && video.hasOwnProperty("workout_id")) {
                props.GetWorkoutWatchedTime(video.workout_id);
            }

            const response = await fetch(
                `https://vimeo.com/api/oembed.json?url=https://player.vimeo.com/video/${video?.video_id}`
            );
            const json = await response.json();
            setAdditionalDetails(json);

            const result = await apiCallV2(
                "GET",
                "get-video-raw-link",
                "",
                localStorage.getItem("access-token"),
                { videoID: video?.video_id }
            );

            let durtemp = video?.video_time || json.duration;
            let thumbtemp = (video?.image || json?.thumbnail_url.split("_")[0]) + "_720x405"
            let per = Math.round(video?.progress?.watchedtime / durtemp * 100);
            let startTime = per > 90 ? 0 : video?.progress?.watchedtime;

            setVideoTitle(json.title);
            setDuration(durtemp);
            setThumbnail(thumbtemp);
            setVideoRawURL(result?.data?.data?.videofiles?.[0]?.link);
            setCastDetails({
                ...video,
                rawUrl: result?.data?.data?.videofiles?.[0]?.link,
                title: json.title,
                duration: durtemp,
                thumbnail: thumbtemp,
                indiMaterialType: type,
                startTime: startTime,
            });
        }


    }, [video?.video_id]);

    // Listen to updated cast detail value for reference
    useEffect(() => {
        props.SetVideoDetails({
            ...castDetails
        });
    }, [castDetails?.video_id, castDetails?.startTime]);

    // List to time counter, neccessary in order to fixed update to 5sec cause timeupdate depends on browser, mostly 250ms.
    useEffect(() => {
        if (timeCounter !== 0 && timeCounter % 5 === 0 && (video.hasOwnProperty("workout_id") || video.hasOwnProperty("id"))) {
            let per = Math.round(timeCounter / duration * 100);
            per = per > 98 ? 100 : per;

            props.SaveWorkoutWatchedtime({
                id: video.workout_id,
                time: timeCounter,
                percentage: per,
            });

            if (per > 80) {
                props.AddFinishedWorkoutID({ ...video, percentage: per, created_at: new Date() });
            }
        }
    }, [timeCounter]);

    useEffect(() => {
        if (play === true) {
            props.Watching();
            PlayVideo();
        }
    }, [play, video?.video_id]);

    useEffect(() => {
        if (native.isPlayingCast) {
            socket.on(`app-native-component-response-${account?.user?.userID}`, async (data) => {
                if (data?.action == "INTERACT_NATIVE") {
                    if (data?.data?.type == "cast") {
                        if (data?.data?.subtype == "sync-position") {
                            SyncFromCast(data?.data?.position);
                        }
                    }
                }
            });
        }
    }, [native.isPlayingCast]);

    const isCasting = native.isPlayingCast && native.playingVideo?.video_id === video?.video_id;

    return (
        <>
            <div key={video?.video_id} style={style} id="custom-video-player" className="image-part">

                {play ? (
                    <>
                        {(!mobileapp)
                            ? <div
                                className="home-page embed-responsive embed-responsive-16by9"
                                id="handstick"
                            >
                                {
                                    videoURL &&
                                    <>
                                        <iframe
                                            ref={iframeRef}
                                            className="home-page iframe-player"
                                            title={videoTitle}
                                            src={videoURL}
                                            allow="autoplay; picture-in-picture"
                                            data-ready
                                            allowfullscreen='true'
                                            webkitallowfullscreen='true'
                                            mozallowfullscreen='true'
                                            responsive='true'
                                        />
                                    </>
                                }

                            </div>
                            : <div id="video-auto-rotate" style={{ display: showFeedV2 ? "inherit" : "none" }}>

                                {
                                    isCasting
                                    && <div className="casting-cover" >
                                        <p>CASTING</p>
                                    </div>
                                }

                                {
                                    showControls && <VideoControls
                                        video={{
                                            videoTitle: videoTitle,
                                            watchedTime: watchedTime,
                                            duration: duration,
                                            videoId: video?.id,
                                            vimeoId: video?.video_id,
                                        }}
                                        fadetype={fadetype}
                                        AlwaysShowControls={AlwaysShowControls}
                                        FadeController={FadeController}
                                        CloseController={CloseController}
                                        CloseVideo={CloseVideo}
                                        playStatus={playStatus}
                                        Pause={Pause}
                                        Resume={Resume}
                                        Move={Move}
                                        Restart={Restart}
                                        PicInPic={PicInPic}
                                        PlayCastDevice={PlayCastDevice}
                                        PauseCastDevice={PauseCastDevice}
                                        SendCastDetails={() => {
                                            props.SendCastDetails2(undefined, watchedTime);
                                        }}
                                        EnableCaption={EnableCaption}
                                        isCaptionEnabled={isCaptionEnabled}
                                        isIntro={isIntro}
                                    />
                                }

                                <div
                                    style={{ display: isCasting ? "none" : "inherit" }}
                                    className={`home-page mobile-feed ${isLandscape ? "landscape" : ""}`}
                                    id="handstick"
                                >
                                    {
                                        videoURL &&
                                        <>
                                            <iframe
                                                ref={iframeRef}
                                                className="home-page iframe-player"
                                                title={videoTitle}
                                                src={videoURL}
                                                allow="autoplay; fullscreen; picture-in-picture"
                                                data-ready
                                                allowfullscreen='true'
                                                webkitallowfullscreen='true'
                                                mozallowfullscreen='true'
                                                responsive='true'
                                            />
                                        </>
                                    }

                                </div>

                            </div>
                        }
                    </>
                ) : (
                    <>
                        {
                            (!thumbnail && !thumbParams)
                                ? <Skeleton variant="rectangular" width={"100%"} height={"100%"} style={{ position: "absolute" }} />
                                : <>
                                    <img
                                        src={thumbParams || thumbnail}
                                        className="home-page"
                                        style={{ width: "100%" }
                                        }
                                    />
                                </>
                        }

                        <div className="play-icon">
                            {
                                (native.isPlayingCast && native.playingVideo?.video_id === video?.video_id && playClicked)
                                    ? ""
                                    : <FaPlay className="play-button" onClick={() => {
                                        if (props.hasOwnProperty("redirect")) {
                                            props.redirect();
                                        } else {
                                            if (mobileapp) {
                                                callSocket("/interact-native-component", { type: "airplay", subtype: "check" });
                                            }

                                            if (mobileapp && native.isPlayingCast) {
                                                setShowFeedV2(true);
                                                props.SendCastDetails2(undefined, watchedTime);
                                                setPlayClicked(true);
                                                setPlay(true)
                                            } else {
                                                if (mobileapp != null) {
                                                    setShowFeedV2(true);
                                                }
                                                setPlay(!play)
                                            }
                                        }
                                    }} />
                            }

                        </div>

                        {
                            (thumbnail || thumbParams) &&
                            <div className="thumbnail-gradient-overlay" >
                                {
                                    label && label({ duration: Math.round(Number(duration / 60)), durationSec: duration })
                                }
                            </div>
                        }
                    </>
                )}

            </div>
        </>
    );
}

const mapStateToProps = (state) => ({
    Favorite: state.Favorite,
    Workout: state.Workout,
    Exercise: state.Exercise,
    User: state.User,
    Cast: state.Cast
});

export default connect(mapStateToProps, {
    SaveWorkoutWatchedtime,
    GetWorkoutWatchedTime,
    AddFinishedWorkoutID,
    SetVideoDetails,
    SendCastDetails2,
    Watching,
})(VideoFeedV2);

